import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PermitService } from 'app/services/permit.service';
import { ToastrService } from 'ngx-toastr';
import { ApplicationService } from 'app/services/application.service';
import { environment } from 'environments/environment';
import { PopupService } from 'app/services/shared/popup.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import {StatusService} from '../../services/status.service';
import {UtilityServiceService} from '../../services/utility-service.service';
import {Router} from '@angular/router';


@Component({
  selector: 'app-permit-certificate-return',
  templateUrl: './permit-certificate-return.component.html',
  styleUrls: ['./permit-certificate-return.component.css']
})
export class PermitCertificateReturnComponent implements OnInit {
  form: FormGroup;
  isLoading: boolean = false;
  message = 'Loading...'
  btnRadio:any;
  statuses: any = [];
  revoke_certificate: boolean = false;
  perm_status_id;
  chosen_permit_id;
  status:any;
  statusId;
  carrier_name_data;
  revoke_reason: any;
  permit:any;
  permit_issue: any;
  selected_perm_status_id;
  button_label: any = "Return Permit";
  constructor(private formBuilder: FormBuilder,private permitSevc:PermitService,private toastService:ToastNotificationService,private statusService: StatusService,private router: Router,private utility:UtilityServiceService,
    private toastr:ToastrService,public applicationService: ApplicationService,private popConfirm: PopupService,private confirmDialogService: ConfirmDialogService) { }

  ngOnInit() {
    this.statusId=this.utility.approveStatusId
    this.initForm();
  }
  initForm() {
    this.form = this.formBuilder.group({
      permit_num: ['', [<any>Validators.required]],
      face_value: ['', [<any>Validators.required]],
      carrier_name: ['', [<any>Validators.required]],
      btnRadio: ['', [<any>Validators.required]],
      revoke_certificate: [false,],
      revoke_reason: ['',],
      selected_perm_status_id: ['',],
    });

    this.button_label = 'Return Permit';
  }
  confirm(){

    if(!this.form.value.permit_num){
      return this.toastService.error('Please enter permit number','Permit Number')
    }
    if(!this.form.value.face_value){
      return this.toastService.error('Please enter face value number','Face Value Number')
    }
    this.isLoading = true;
    let permit_issue = 0;
    if (this.form.value.permit_num.includes('/')){
      permit_issue = this.form.value.permit_num.substring(this.form.value.permit_num.indexOf('/')+1).trim();
      if(!permit_issue){
        permit_issue = 0
      }
      this.form.value.permit_num = this.form.value.permit_num.substring(0, this.form.value.permit_num.indexOf('/'));
        }

    this.permitSevc.getPermitReturn(this.form.value.permit_num).subscribe((data: any) =>{
      this.permit = data;

      if(data.face_value_num != this.form.value.face_value){
        this.isLoading = false;
        return this.toastService.error('Sorry permit and face value numbers do not match','Face Value Number')
      }

      if(data.permit_issue != permit_issue){
        this.isLoading = false;
        return this.toastService.error('Unable to locate the permit using permit number.','Permit Number')
      }

      this.permit = data;
      console.log("New Permit Status",this.permit);

      this.applicationService.getById(this.permit.application_id).subscribe((data:any) =>{
        console.log("Application",data);
       this.loadData(data)
        let status_id = +environment.authWebApi.systemData.Configurations.find(config => config.Code == "PermitStatus5").Value;
       console.log("status_id",status_id);
        this.perm_status_id = data.status_id;
        this.getStatus();
        //check status

        if(this.permit.status_id === status_id){
          this.isLoading = false;
          return this.toastService.error('Permit already returned','Permit');
        }

      });

    },err =>{
      this.isLoading = false;
      return this.toastService.error('Unable to locate the permit using permit number.','Permit Number')
    })
  }
  loadData(data: any) {
    console.log("On load data",data);
    this.carrier_name_data = data.carrier.name;
    console.log("Carrier Name data", this.carrier_name_data + "-" + data.carrier.name);
    this.form.patchValue({
      carrier_name:data.carrier.name

    });
  }
  onConfirm(data) {
    let status_id = +environment.authWebApi.systemData.Configurations.find(config => config.Code == "PermitStatus5").Value;

    this.popConfirm.showYesNo('Permit Not Expired', `The permit for carrier ${data.carrier.name}  is not expired! Do you want to return it anyway?`, null,'Yes', 'No')
                .subscribe((isConfirmed) => {
                  if (isConfirmed) {
                    this.isLoading = true;
                    data.permit.status_id = status_id;
                      data.status_id = status_id;
                      this.applicationService.update(data).subscribe(x =>{
                        //console.log(x)
                        this.permitSevc.upadatePermit(data.permit).subscribe(result => {
                          this.isLoading = false;
                          this.issuePermitRevocation();
                          return this.toastService.success('Permit returned successfully','Permit');
                        })
                      })
                  } else {         
                    return;
                  }
                });
                this.confirmDialogService.confirmThis(`The permit for carrier ${data.carrier.name}  is not expired! Do you want to return it anyway?`, () => {  
          
                    this.isLoading = true;
                    data.permit.status_id = status_id;
                      data.status_id = status_id;
                      this.applicationService.update(data).subscribe(x =>{
                        //console.log(x)
                        this.permitSevc.upadatePermit(data.permit).subscribe(result => {
                          this.isLoading = false;
                          this.issuePermitRevocation();
                          return this.toastService.success('Permit returned successfully','Permit');
                        })
                      })
                 
      
                }, () =>  {  
                  return;
                }) 
  }
  revokeCertificate(data) {
  this.revoke_certificate = !this.revoke_certificate;
    if(this.permit?.document_guid !== null && this.permit?.document_guid!== undefined && this.revoke_certificate){
      this.button_label = 'Return & Revoke Permit'
    }else{
      this.button_label = 'Return Permit'
    }
  }

  getStatus(){
    this.statusService.getAll().subscribe((x:any) => {

      this.statuses = x.filter(s=>s.id != 51);
      this.statuses.sort((a,b) => a.sort_order > b.sort_order ? 1 : -1 &&  a.group_code > b.group_code ? 1 : -1 &&  a.id > b.id ? 1 : -1);

      this.status = this.statuses.find(x => x.id ==  this.perm_status_id);
      console.log("STATUS",this.status);

      var tmpStatuses: any = [];
      this.statuses.forEach(y => {

        if (y.group_code > this.status?.group_code ) {
          tmpStatuses.push(y);
        }
      });
      this.statuses = tmpStatuses;
    })
  }

  statusUpdate(event) {
    const value = event.target.value;
    console.log("Selected Status",   value)
    this.selected_perm_status_id = value;
  }

  returnPermit(){

    this.isLoading = true;
    this.applicationService.getById(this.permit.application_id).subscribe((data:any) =>{
    //   console.log(data)
    //   this.loadData(this.permit);
      let status_id = +environment.authWebApi.systemData.Configurations.find(config => config.Code == "PermitStatus5").Value;
      this.selected_perm_status_id == this.permit.status_id ? this.permit.status_id :status_id;
      //check status

      if(this.perm_status_id === this.selected_perm_status_id){
        this.isLoading = false;
        return this.toastService.error('Permit already returned, please choose another one','Permit');
      }

      //get permit type date
      let createdDate = new Date(this.perm_status_id?.date_valid_to);
      // if(data.permit_type.permit_months > 0){
      //   createdDate.setMonth(createdDate.getMonth() + data.permit_type.permit_months)
      //   }

      //   if(data.permit_type.permit_days > 0){
      //   createdDate.setDate(createdDate.getDate() + data.permit_type.permit_days)

      //   }
      //   if(data.permit_type.permit_years > 0){
      //   createdDate.setFullYear(createdDate.getFullYear() + data.permit_type.permit_years)

      //   }

      let checkNowDate = new Date();
      //check expiry date
      //console.log('current date'+createdDate)
      //console.log('now date'+checkNowDate)

      if (createdDate.getTime() > checkNowDate.getTime()){
        this.isLoading = false;
        return this.onConfirm(this.permit);
      }


      //TO DO
      this.permit.date_12 = new Date();
      this.permit.status_id = status_id;
      data.status_id = status_id;
      // this.applicationService.update(data).subscribe(x =>{
        //console.log(x)
        this.permitSevc.upadatePermit(this.permit).subscribe(result => {
          this.isLoading = false;
        });
      // })

    this.issuePermitRevocation();

    });




  }
  issuePermitRevocation(){
    if(this.permit.document_guid !== null && this.permit.document_guid!== undefined && this.revoke_certificate){
      this.permitSevc.RevokePermit(this.permit.ID, this.revoke_reason).toPromise().then((response) => {
        console.log(response);
        this.isLoading = false;
        // this.notify.success("Permit has been revoked successfully.", "Permit Revocation", { timeOut: 1000 });
        this.toastService.success('Permit has been revoked successfully.', 'Permit Revocation!')
        this.permit.document_guid = null;
        this.router.navigateByUrl('/permit/approval');
      })
    }else{
      this.toastService.success('Permit returned successfully','Permit');
      this.router.navigateByUrl('/permit/approval');
    }
  }
}
